module.exports = "/_next/static/images/sprite-icons-4871290c3f8fcdc39decec741d4537bc.svg";